import React from "react";
import "../styles/WhatStandOut.scss";
import express from "../assets/mumbai-pune-expressway.PNG";
import ringroad from "../assets/ringroad.PNG";
import graph from "../assets/graph.png";
import tourism from "../assets/tourism.PNG";

function WhatStandOut() {
  const cards = [
    {
      title: "Potential For Capital Appreciation",
      content:
        `Lonavala region - 19-26 % Annually seen in past year & Khandshi has seen 9.31 % in past year.`,
      img: graph,
    },
    {
      title: "Infrastructure Impact",
      content: "The completion of the Mumbai-Pune Expressway line.",
      img: express,
    },
    {
      title: "Impact and improvements",
      content: "Ring Road (Western Phase)",
      img: ringroad,
    },
    {
      title: "Growing Tourism and Demand",
      content: "Increased tourism in the Lonavala region. Average Lonavala attracts nearly 14 lakh tourists annually (1.4 million)",
      img: tourism,
    },
    {
      title: "Projected Appreciation Rates",
      content: `Historical Kamshet land appreciation: 15–20% Annually over last 3 Years.
      Expected next 3 Years: 10–15% annually (excluding expressway effect).
      Expressway impact could add +25–35% short-term boost.`,
      img: graph,
    },
    {
      title: "Additional Income Potential",
      content:
        "NA plots can generate 8–12% ROI annually through resort/farmhouse rentals.",
      icon: "+",
    },
  ];

  return (
    <div className="what-stand-out">
      <h2 className="heading">
        What makes Khandshi Stand Out In Lonavala Region?
      </h2>

      <div className="container">



        <div className="cards-container">
          {cards.map((card, index) => (
            <div className="card" key={index}>
              {card.img && (
                <div className="card-image">
                  <img src={card.img} alt={card.title} />
                </div>
              )}
              {card.icon && <div className="card-icon">{card.icon}</div>}
              <h3 className="card-title">{card.title}</h3>
              <p className="card-content">
                {card.content.split('\n').map((line, index) => (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WhatStandOut;
